import React from "react";
import Typography from "@material-ui/core/Typography";
import { GetApp } from "@material-ui/icons";
import { GridToolbarContainer } from "@material-ui/data-grid";

import Button from "../../../components/elements/Button";
import classes from "./InvoicesDashboard.module.scss";

type ToolbarProps = {
  onExport: () => void;
  isExportDisabled: boolean;
  isLoading: boolean;
};

const InvoicesDashboardToolbar: React.FC<ToolbarProps> = ({ onExport, isExportDisabled, isLoading }) => {
  return (
    <GridToolbarContainer className={classes.dashboardControls}>
      <Typography>Invoices</Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<GetApp />}
        disabled={isExportDisabled || isLoading}
        onClick={onExport}
        isLoading={isLoading}
      >
        Export
      </Button>
    </GridToolbarContainer>
  );
};

export default InvoicesDashboardToolbar;
